
import {
  Component,
  Emit,
  Prop,
  Ref,
  VModel,
  Watch,
  mixins,
} from 'nuxt-property-decorator'
import { SearchQuery } from './types'
import PrefixMixin from '~/utils/mixins/prefixMixin'
import KeyboardEventsMixin from '~/utils/mixins/keyboardEventsMixin'
import { NeoAutocomplete } from '@kodadot1/brick'
import { useCollectionSearch } from '@/components/search/utils/useCollectionSearch'

@Component({
  components: {
    SearchSuggestion: () => import('./SearchSuggestion.vue'),
    NeoAutocomplete,
  },
})
export default class SearchBar extends mixins(
  PrefixMixin,
  KeyboardEventsMixin
) {
  @Prop({ type: Object, required: false }) public query!: SearchQuery
  @VModel({ type: String }) name!: string
  @Ref('searchRef') readonly searchRef
  @Ref('searchSuggestionRef') readonly searchSuggestionRef
  private enableSearchInCollection = true
  public inputFocused = false

  public created() {
    this.initKeyboardEventHandler({
      k: this.bindSearchEvents,
    })
    this.onSearchInCollectionModeChanged()
  }

  get isSearchInCollectionMode() {
    return useCollectionSearch().isCollectionSearchMode.value
  }

  get placeholderContent() {
    return this.inputFocused || this.isSearchInCollectionMode
      ? ''
      : this.$t('general.searchPlaceholder')
  }

  get showDefaultSuggestions() {
    return this.urlPrefix === 'rmrk' || this.urlPrefix === 'bsx'
  }

  public exitCollectionSearch() {
    if (this.isSearchInCollectionMode && !this.name) {
      this.enableSearchInCollection = false
    }
  }

  @Emit('enter')
  @Emit('redirect')
  onEnter() {
    this.closeDropDown()
    this.searchRef?.$refs?.input?.$refs?.input?.blur()
    // insert search term in history
    this.searchSuggestionRef?.insertNewHistory()
  }

  public focusInput(): void {
    this.searchRef?.focus()
  }

  public onInputFocus(): void {
    this.inputFocused = true
  }

  public onInputBlur(): void {
    this.$emit('blur')
    this.inputFocused = false
    if (!this.name) {
      this.enableSearchInCollection = true
    }
  }

  private bindSearchEvents(event) {
    event.preventDefault()
    if (
      event.key === 'k' &&
      this.searchRef?.$el?.getBoundingClientRect()?.top > 0
    ) {
      this.focusInput()
    }
  }

  public closeDropDown() {
    this.searchRef.isActive = false
  }

  @Watch('enableSearchInCollection', { immediate: true })
  private onSearchInCollectionModeChanged() {
    useCollectionSearch().setCollectionSearchMode(this.enableSearchInCollection)
  }
}
